import { render, staticRenderFns } from "./DetailsRight.vue?vue&type=template&id=c74fe382&scoped=true"
import script from "./DetailsRight.ts?vue&type=script&lang=ts&external"
export * from "./DetailsRight.ts?vue&type=script&lang=ts&external"
import style0 from "./DetailsRight.vue?vue&type=style&index=0&id=c74fe382&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74fe382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74fe382')) {
      api.createRecord('c74fe382', component.options)
    } else {
      api.reload('c74fe382', component.options)
    }
    module.hot.accept("./DetailsRight.vue?vue&type=template&id=c74fe382&scoped=true", function () {
      api.rerender('c74fe382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/details/Right/DetailsRight.vue"
export default component.exports